import { nanoid } from 'nanoid';
import { defineStore } from 'pinia';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import type { BadgeInput, BadgeStored } from './types';

export const useBadgeStore = wrapPiniaStore(
  defineStore('badge', () => {
    const badges = ref<BadgeStored[]>([]);

    function showBadge(badge: BadgeInput) {
      const fullBadge = {
        ...badge,
        id: badge.id ?? nanoid(),
        type: badge.type ?? 'default',
      };

      badges.value.push(fullBadge);

      if (badges.value.length > 4) {
        badges.value.shift();
      }

      const timeout = 3_000 + fullBadge.content.length * 100;

      setTimeout(() => hideBadge(fullBadge.id), timeout);

      return fullBadge.id;
    }

    function hideBadge(id: string) {
      badges.value = badges.value.filter((badge) => badge.id !== id);
    }

    return {
      badges,
      showBadge,
      hideBadge,
    };
  }),
);
